<header>
  <h2>{{ "settings.client-rules-questions" | transloco }}</h2>
  <div class="config-row">
    <div
      class="ui toggle checkbox config-toggle"
      (click)="toggleConfigOperationMode(configOperations.export)"
    >
      <input type="checkbox" [ngModel]="configExportMode" />
      <label>{{ "settings.export-config-mode" | transloco }}</label>
    </div>
    @if (!isProductionMode) {
    <div
      class="ui toggle checkbox config-toggle"
      (click)="toggleConfigOperationMode(configOperations.delete)"
    >
      <input type="checkbox" [ngModel]="configDeleteMode" />
      <label>{{ "settings.delete-config-mode" | transloco }}</label>
    </div>
    }
  </div>

  <div id="filters">
    @if (taxYear) {
    <app-search-dropdown
      label="{{ yearLabel }}"
      [formGroup]="searchForm"
      [formCtrl]="taxYear"
      [listOptions]="taxYearOptions"
    ></app-search-dropdown>
    } @if (configExportMode || configDeleteMode) {
    <div class="config-date">
      <input
        type="date"
        placeholder="From date"
        [(ngModel)]="configOperationDate"
        onkeydown="return false"
        [disabled]="loading"
        (change)="filterQuestionsOnDateChange()"
      />
    </div>
    } @if (configExportMode || configDeleteMode) {
    <button
      class="ui primary button background tiny config-button"
      (click)="openConfigOperationConfimationModal(configOperation)"
    >
      {{
        configExportMode
          ? ("settings.download-config" | transloco)
          : ("settings.delete-config" | transloco)
      }}
    </button>
    } @if (!configExportMode && !configDeleteMode) {
    <div id="question-type-filter">
      <label>{{ "settings.include" | transloco }}</label>
      <select
        class="ui fluid normal multi-select dropdown"
        multiple=""
        [(ngModel)]="questionTypeFilter"
      >
        <option value="all">All</option>
        <option value="text">Text</option>
        <option value="number">Number</option>
        <option value="date picker">Date Picker</option>
        <option value="textarea">Textarea</option>
        <option value="drop down">Dropdown</option>
        <option value="people">People Picker</option>
        <option value="radio">Radio</option>
        <option value="checkbox">Checkbox</option>
        <option value="table">Table</option>
        <option value="file">File</option>
      </select>
    </div>
    } @if (!configExportMode && !configDeleteMode) {
    <div id="keyword-filter">
      <div class="ui left icon fluid input">
        <i class="search icon"></i>
        <input
          type="text"
          [(ngModel)]="questionSearch"
          placeholder="{{ 'settings.search-questions' | transloco }}"
        />
      </div>
    </div>
    } @if (!configExportMode && !configDeleteMode && !isProductionMode) {
    <div
      id="create-new"
      class="ui primary background button"
      [routerLink]="['new']"
      [queryParams]="{ taxYear: taxYear?.value?.value }"
    >
      {{ "settings.new-question" | transloco }}
    </div>
    } @if (!configExportMode && !configDeleteMode && !isProductionMode) {
    <div
      id="create-backup"
      class="ui primary background button backup_button"
      (click)="createBackup()"
      [ngClass]="{ loading: creatingBackup }"
    >
      {{ "settings.Create-Backup" | transloco }}
    </div>
    }
  </div>
</header>

@if (loading) {
<div>
  <div class="ui active centered inline loader"></div>
</div>
} @if (!loading && questions?.length == 0 || (!loading &&
questionsForConfigOperation?.length == 0 && (configExportMode ||
configDeleteMode))) {
<div id="no-results">{{ "settings.no-questions-found" | transloco }}</div>
} @if (!loading && questions?.length > 0 && !configExportMode &&
!configDeleteMode) {
<table id="list" width="100%" cellspacing="0">
  <thead>
    <tr>
      <td width="500px">{{ "settings.question" | transloco }}</td>
      <td width="200px" class="no-wrap">
        {{ "settings.type-of-field" | transloco }}
      </td>
      <td width="200px" class="no-wrap">
        {{ "settings.mandatory" | transloco }}
      </td>
      @if (!isProductionMode) {
      <td></td>
      }
    </tr>
  </thead>
  <tbody>
    @for (question of questions | keyWord:['question', 'APSRef']:questionSearch
    | questionType:questionTypeFilter; track question) {
    <tr [routerLink]="[question?.id]">
      <td>
        @if (showQuestionId) {
        <span>{{ question?.id }}.</span>
        } {{ question?.question }}
      </td>
      <td>{{ question?.questionType }}</td>
      <td>{{ question?.mandatory ? "Yes" : "No" }}</td>
      @if (!isProductionMode) {
      <td align="right" class="btn">{{ "settings.edit" | transloco }}</td>
      }
    </tr>
    }
  </tbody>
</table>
} @if (!loading && questionsForConfigOperation?.length > 0 && (configExportMode
|| configDeleteMode)) {
<table id="list" width="100%" cellspacing="0">
  <thead>
    <tr>
      <td>
        @if (!configDeleteMode) {
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="entireListSelected"
            (change)="entireListSelection()"
          /><label>&nbsp;</label>
        </div>
        }
      </td>
      <td width="500px">{{ "settings.question" | transloco }}</td>
      <td width="200px" class="no-wrap">
        {{ "settings.type-of-field" | transloco }}
      </td>
      <td width="200px" class="no-wrap">
        {{ "settings.mandatory" | transloco }}
      </td>
      <td>{{ "settings.created" | transloco }}</td>
      <td>{{ "settings.updated" | transloco }}</td>
    </tr>
  </thead>
  <tbody>
    @for (question of questionsForConfigOperation; track question) {
    <tr>
      <td>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="question.selected"
            (change)="listSelection()"
          /><label>&nbsp;</label>
        </div>
      </td>
      <td>
        @if (showQuestionId) {
        <span>{{ question?.id }}.</span>
        } {{ question?.question }}
      </td>
      <td>{{ question?.questionType }}</td>
      <td>{{ question?.mandatory ? "Yes" : "No" }}</td>
      <td>{{ question?.displayCreatedAt }}</td>
      <td>{{ question?.displayUpdatedAt }}</td>
    </tr>
    }
  </tbody>
</table>
}

<div #configExportConfimationModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>
    {{ "settings.please-confirm-the-selected-config-to-export" | transloco }}
  </p>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>{{ "settings.question" | transloco }}</th>
        <th>{{ "settings.updated" | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (question of selectedQuestions; track question) {
      <tr>
        <td>
          @if (showQuestionId) {
          <span>{{ question?.id }}.</span>
          } {{ question?.question }}
        </td>
        <td>{{ question.displayUpdatedAt }}</td>
      </tr>
      }
    </tbody>
  </table>
  @if (!selectedQuestions.length) {
  <p>{{ "settings.nothing-selected" | transloco }}</p>
  }
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="downloadConfig()"
  >
    {{ "settings.download" | transloco }}
  </button>
</div>

<div #configDeleteCheckModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>
    {{ "settings.please-confirm-the-selected-config-to-delete" | transloco }}
  </p>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>{{ "settings.question" | transloco }}</th>
        <th>{{ "settings.updated" | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (question of selectedQuestions; track question) {
      <tr>
        <td>
          @if (showQuestionId) {
          <span>{{ question?.id }}.</span>
          } {{ question?.question }}
        </td>
        <td>{{ question.displayUpdatedAt }}</td>
      </tr>
      }
    </tbody>
  </table>
  @if (!selectedQuestions.length) {
  <p>{{ "settings.nothing-selected" | transloco }}</p>
  }
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="deleteConfig({ confirmed: false, event: $event })"
  >
    {{ "settings.delete" | transloco }}
  </button>
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="clearDeleteConfig()"
  >
    {{ "settings.cancel" | transloco }}
  </button>
</div>

<div #configDeleteConfimationModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  @if (configDeletePossible) {
  <h2>{{ "settings.confirm-deletion" | transloco }}</h2>
  }
  <p>
    {{
      configDeletePossible
        ? ("settings.Deletion-of-the-selected-config-is-possible-Following-items-will-be-deleted-would-you-like-to-continue"
          | transloco)
        : ("settings.Deletion-of-the-selected-config-is-not-possible-resolve-the-dependencies-and-try-again"
          | transloco)
    }}
  </p>
  <div class="config-delete-table">
    <h4 class="config-delete-subtitle">
      {{ "settings.client-questions-titlecase" | transloco }}
    </h4>
    <table class="ui striped table">
      <thead>
        <tr>
          <th class="config-delete-id">{{ "settings.id" | transloco }}</th>
          <th>{{ "settings.question" | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        @for (question of deleteQuestions; track question) {
        <tr>
          <td class="config-delete-id">{{ question.id }}</td>
          <td>
            <div>
              <div>{{ question.question }}</div>
              @if (question.parentDependencies?.length) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Dependent-Child-Questions" | transloco }}
                  </div>
                  <ul>
                    @for (pq of question.parentDependencies; track pq) {
                    <li class="config-delete-dep-row">
                      {{ pq.id }} - {{ pq.question }}
                    </li>
                    }
                  </ul>
                </div>
              </div>
              } @if (question.mandatoryParentDependencies?.length) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Dependent-Mandatory-Questions" | transloco }}
                  </div>
                  <ul>
                    @for (mpq of question.mandatoryParentDependencies; track
                    mpq) {
                    <li class="config-delete-dep-row">
                      {{ mpq.id }} - {{ mpq.question }}
                    </li>
                    }
                  </ul>
                </div>
              </div>
              } @if (question.calcDependencies?.length) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Dependent-Calc-Plans" | transloco }}
                  </div>
                  <ul>
                    @for (cp of question.calcDependencies; track cp) {
                    <li class="config-delete-dep-row">{{ cp }}</li>
                    }
                  </ul>
                </div>
              </div>
              } @if (configDeletePossible && question.clientQuestionDropdowns &&
              question.clientQuestionDropdowns.length) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.drop-downs" | transloco }}
                  </div>
                  <ul>
                    @for (dropdown of question.clientQuestionDropdowns; track
                    dropdown) {
                    <li class="config-delete-dep-row">
                      {{ dropdown.id }} - {{ dropdown.display }}
                    </li>
                    }
                  </ul>
                </div>
              </div>
              } @if (configDeletePossible) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Total-Answers" | transloco }} -
                    {{ question.totalAnswers || 0 }}
                  </div>
                </div>
              </div>
              }
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  @if (deleteCategories && deleteCategories.length) {
  <div class="config-delete-table">
    <h4 class="config-delete-subtitle">
      {{ "settings.client-categories" | transloco }}
    </h4>
    <table class="ui striped table">
      <thead>
        <tr>
          <th class="config-delete-id">{{ "settings.id" | transloco }}</th>
          <th>{{ "settings.name" | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        @for (category of deleteCategories; track category) {
        <tr>
          <td class="config-delete-id">{{ category.id }}</td>
          <td>{{ category.name }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  } @if (configDeletePossible) {
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="deleteConfig({ confirmed: true, event: $event })"
  >
    {{ "settings.confirm" | transloco }}
  </button>
  }
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="clearDeleteConfig()"
  >
    {{ "settings.cancel" | transloco }}
  </button>
</div>
